export default "__VITE_ASSET__Cym$wgbN__"